import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ErrorsRoutes } from './errors.routes';

/**
 * Components
 */
import { PageErrorsComponent } from './page-errors/page-errors.component';
import { PagePermissionComponent } from './page-permission/page-permission.component';
import { PageDeletedComponent } from './page-deleted/page-deleted.component';


@NgModule({
  declarations: [
    PageErrorsComponent,
    PagePermissionComponent,
    PageDeletedComponent
  ],
  exports: [
    PageErrorsComponent,
    PagePermissionComponent,
    PageDeletedComponent
  ],
  imports: [
    RouterModule.forChild(ErrorsRoutes),
    CommonModule
  ],
  providers: [],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})

export class ErrorsModule {}
